import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { GdxModalPageModule } from '../../../components/gdx-modal/gdx-modal.module';
import { ModalStorageRequestPermissionPage } from './modal-storage-request-permission';

@NgModule({
  declarations: [
    ModalStorageRequestPermissionPage,
  ],
  imports: [
    IonicPageModule.forChild(ModalStorageRequestPermissionPage),
    FlexLayoutModule,
    GdxModalPageModule,
    TranslateModule
  ],
})
export class ModalStorageRequestPermissionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/general/modal-storage-request-permission/modal-storage-request-permission.module.ts